import { useLazyQuery, useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  GetOutpatientQuestionnaireUnreadOrganizationNotificationDocument,
  MarkOrganizationNotificationDocument,
} from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';
import { outpatientQuestionnaireEntryProfileDrawerState } from '~/state/reception/atoms';

export const useMarkNotification = () => {
  const { outpatientQuestionnaireEntryId } = useAtomValue(
    outpatientQuestionnaireEntryProfileDrawerState,
  );
  const [markNotification] = useMutation(MarkOrganizationNotificationDocument);
  const [getNotifications, { data: notificationsData }] = useLazyQuery(
    GetOutpatientQuestionnaireUnreadOrganizationNotificationDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (!notificationsData) return;

    const notifications =
      getNode(notificationsData, 'OutpatientQuestionnaireEntry')?.unreadOrganizationNotifications ||
      [];
    for (const notification of notifications) {
      markNotification({
        variables: {
          input: {
            organizationNotificationId: notification.id,
          },
        },
      });
    }
  }, [markNotification, notificationsData]);

  useEffect(() => {
    if (outpatientQuestionnaireEntryId) {
      getNotifications({
        variables: {
          outpatientQuestionnaireEntryId,
        },
      });
    }
  }, [outpatientQuestionnaireEntryId, getNotifications]);
};
